<script>
  import {fly} from 'svelte/transition';

  // two-way
  export let visible = false;
  export let close;

  export let title = 'BLABLA';
  export let onClose = null;
  export let width = window.screen.width > 500 ? Math.min(600, window.screen.width * 0.8) : null;
  export let height = window.screen.width > 500 ? Math.min(800, window.screen.height * 0.8) : null;


  const onClickClose = () => {
    close();
    onClose && onClose();
  };

  const onKeyDown = e => {
    if (e.key !== 'Escape') return;

    onClickClose();
  };
</script>

<svelte:window on:keydown={onKeyDown}></svelte:window>

<div class="modal-backdrop" class:visible={visible} on:click={onClickClose}></div>

{#if visible}
  <column
      class="modal-container"
      class:visible={visible}
      style={`${width ? `width: ${width}${typeof width === 'string' ? '' : 'px'};` : ''} ${height ? `height: ${height}${typeof height === 'string' ? '' : 'px'}` : ''}`}
      transition:fly={{
        y: window.screen.height,
        duration: 300
      }}
  >
    <row class="header">
      <button class="button-close clickable" on:click={onClickClose}>
        <ion-icon name="close-outline"></ion-icon>
      </button>

      <div class="title">
          {title}
      </div>
    </row>

    <column expand class="modal-content">
      <slot></slot>
    </column>
  </column>
{/if}


<style>
  .modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
    transition: opacity .3s;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 2;
    pointer-events: none;
  }

  .modal-backdrop.visible {
    opacity: 1;
    pointer-events: auto;
  }

  .modal-container {
    background-color: white;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    width: 100%;
    height: 100%;
    z-index: 3;
  }

  .header {
    position: relative;
    height: 48px;
    border-bottom: 1px solid #eee;
  }

  .button-close {
    font-size: 20px;
    width: 48px;
    height: 48px;
    background: none;
    border: none;
  }

  .title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .modal-content {
    overflow: auto;
  }

</style>